import React, { useEffect, useState } from "react";
import InputRC from "components/ui/forms/InputRC";
import { useForm } from "react-hook-form";
import InputField from "components/ui/forms/InputField";
import Button from "components/ui/Button";
import barcodeOuter from "assets/images/barcodeOuter.svg";
import barcodeInner from "assets/images/barcodeInner.svg";
import authentication from "assets/icons/icon-2fa.png";
import InputSwitch from "components/ui/forms/InputSwitch";
import { useTranslation } from "react-i18next";
const TwoStepAuthentication = () => {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });
  const [isLgScreen, setIsLgScreen] = useState(window.innerWidth >= 1024);
  const [step, setStep] = useState(1);
  const watchLastName = watch("sixdigit");

  useEffect(() => {
    const handleResize = () => setIsLgScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onSubmit = (data) => {
    //console.log(data);
  };
  const handleNextStep = () => setStep(2);
  const handlePrevStep = () => setStep(1);

  return (
    <>
      <div className="flex justify-between py-2">
        <img className="w-[35px] h-[35px] bg-[rgb(255,255,255,1)] p-1 rounded" src={authentication} alt="authentication-image" />
        <InputSwitch />
      </div>
      <h1 className="text-[rgb(255,255,255,1)] lg:mb-6 mb-2 sm:mb-0">{t("Activate two-factor authentication")}</h1>
      <div className="lg:bg-[rgb(255,255,255,.05)] w-full lg:max-w-[80%] m-auto lg:p-[18px] rounded">
        {step === 1 && (
          <>
            <span className="text-[14px] text-[rgb(255,255,255,1)] leading-[1.5] font-medium">{t("Set up Authenticator")}</span>
            <p className="text-[rgb(255,255,255,.5)] text-[12px] leading-[1.5]">{t("googleAuthQRText")}</p>
          </>
        )}

        {/* QR Code Section */}
        {(isLgScreen || step === 1) && (
          <div className="flex justify-center my-4">
            <div className="w-[135px] h-[135px] relative">
              <img src={barcodeOuter} alt="Barcode Outer" />
              <img className="bg-white p-1 absolute top-[8px] left-[8px]" src={barcodeInner} alt="Barcode Inner" />
              <p className="cursor-pointer text-[#4f85d9] text-[14px] font-normal leading-[16px] uppercase text-center mb-[20px] mt-[20px]">
                {t("Can’t scan it?")}
              </p>
            </div>
          </div>
        )}
        {!isLgScreen && step === 2 && (
          <div className="flex gap-2 z-10 w-full pt-2 mb-2 border-t border-[rgb(255,255,255,.05)]" onClick={handlePrevStep}>
            <i className="text-[rgb(255,255,255,.8)] text-[20px] bc-i-round-arrow-left"></i>
            <span className="text-[rgb(255,255,255,1)] uppercase text-[14px]">{t("Set up Authenticator")}</span>
          </div>
        )}

        {(isLgScreen || step === 2) && (
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="lg:mt-[3.5rem]">
              <InputField
                type="text"
                name="sixdigit"
                label="Enter the 6-digit code that you see in the App"
                control={control}
                rules={{
                  pattern: {
                    value: /^\d{6}$/,
                  },
                }}
              />
              <div className="w-full z-10 bottom-0 pt-5">
                <Button
                  label={t("Verify")}
                  type="submit"
                  size="small"
                  variant="green"
                  className="uppercase md:max-w-[370px] w-full ml-auto"
                  disabled={errors.sixdigit || !watchLastName || watchLastName.length !== 6}
                />
              </div>
            </div>
          </form>
        )}
        {!isLgScreen && step === 1 && (
          <div className=" z-10 mt-[3.5rem] w-full">
            <Button
              label="Next"
              type="button"
              size="small"
              variant="blue"
              className="uppercase text-[rgb(255,255,255,2)] bg-[rgb(16,145,33,1)] w-full h-[36px]"
              onClick={handleNextStep}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default TwoStepAuthentication;
